module.exports = __webpack_public_path__ + "img/concern_detail.0bf46724.png";